import { TemplateGenerator, TemplateOptions } from '../../templates/generator';
import { FrameworkInfo } from './framework-detector';

export async function generateAllTemplates(config: {
  framework: FrameworkInfo;
  typescript?: boolean;
  features?: string[];
  security?: {
    authentication?: boolean;
    rateLimit?: boolean;
    cors?: boolean;
  };
  writeFiles?: boolean;
  scanPaths?: string[];
  include?: string[];
  exclude?: string[];
}): Promise<{ path: string; content: string; type: string }[]> {
  const generator = new TemplateGenerator();
  
  const options: TemplateOptions = {
    framework: config.framework,
    typescript: config.typescript !== false,
    features: config.features || [],
    auth: config.security?.authentication || false,
    rateLimit: config.security?.rateLimit || false,
    cors: config.security?.cors || true, // Default CORS to true
  };
  
  // Generate all files
  const apiRoutes = generator.generateApiRoutes(options);
  const middleware = generator.generateMiddleware(options);
  const configFile = generator.generateConfigFile({
    ...options,
    scanPaths: config.scanPaths,
    include: config.include,
    exclude: config.exclude,
  });
  
  const allFiles = [...apiRoutes, ...middleware, configFile];
  
  // Write files only if requested (default true for backward compatibility)
  if (config.writeFiles !== false) {
    await generator.writeFiles(allFiles);
  }
  
  return allFiles;
}